export default "__VITE_ASSET__3zdMwPAj__"